import {
	IBusTuyenDuongSelectChuaPhanTuyenRequest,
	IBusTuyenDuongUpdatePhanTuyenHocSinhRequest
} from '../../../api/bus/busTuyenDuongApi';
import { IBusTuyenDuongChiTietSelectRequest } from '../../../api/bus/busTuyenDuongChiTietApi';
import { IBusTuyenDuongSelectRequest } from '../../../models/request/bus/busBaoCaoDiemDanhRequest';
import { IUploadExcelTuyenDuongChiTietRequest } from '../../../models/request/bus/uploadExcelRequest';
import { BusHocSinhChuaPhanTuyenResponse } from '../../../models/response/bus/bus_dangkyxe';
import { BusDiemDonTraItemResponse } from '../../../models/response/bus/bus_diemdontra';
import { bus_loaidiemdon } from '../../../models/response/bus/bus_loaidiemdon';
import {
	bus_tuyenduong_chitiet,
	BusTuyenDuongChiTietItemResponse
} from '../../../models/response/bus/bus_tuyenduong_chitiet';
import { BusPhanTuyenItemResponse } from '../../../models/response/bus/BusPhanTuyenItemResponse';

/** Huỷ đăng ký xe của 1 học sinh (bỏ học sinh khỏi tuyến hiện tại) */
export interface IBusPhanTuyenHuyDangKyRequest {
	ts_hocsinh_id: number;
	bus_diemdontra_id: number;
	nam_hoc: string;
}
/** Thông tin mở modal thêm học sinh vào 1 điểm đón trả của tuyến */
export interface IBusPhanTuyenAddHocSinhRequest {
	bus_tuyenduong_id: number;
	bus_diemdontra_id: number;
}

export enum eBusPhanTuyenActionTypeIds {
	LOAD_START = "BUS_PHANTUYEN_LOAD_START",
	LOAD_SUCCESS = "BUS_PHANTUYEN_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_PHANTUYEN_LOAD_ERROR",

	LOAD_TUYENDUONG_CHITIET_START = "BUS_PHANTUYEN_LOAD_TUYENDUONG_CHITIET_START",
	LOAD_TUYENDUONG_CHITIET_SUCCESS = "BUS_PHANTUYEN_LOAD_TUYENDUONG_CHITIET_SUCCESS",
	LOAD_TUYENDUONG_CHITIET_ERROR = "BUS_PHANTUYEN_LOAD_TUYENDUONG_CHITIET_ERROR",

	LOAD_DIEMDONTRA_START = "BUS_PHANTUYEN_LOAD_DIEMDONTRA_START",
	LOAD_DIEMDONTRA_SUCCESS = "BUS_PHANTUYEN_LOAD_DIEMDONTRA_SUCCESS",
	LOAD_DIEMDONTRA_ERROR = "BUS_PHANTUYEN_LOAD_DIEMDONTRA_ERROR",

	LOAD_LOAIDIEMDON_START = "BUS_PHANTUYEN_LOAD_LOAIDIEMDON_START",
	LOAD_LOAIDIEMDON_SUCCESS = "BUS_PHANTUYEN_LOAD_LOAIDIEMDON_SUCCESS",
	LOAD_LOAIDIEMDON_ERROR = "BUS_PHANTUYEN_LOAD_LOAIDIEMDON_ERROR",

	SHOW_TUYENDUONG_CHITIET_DETAIL = "BUS_PHANTUYEN_SHOW_TUYENDUONG_CHITIET_DETAIL",
	CLOSE_TUYENDUONG_CHITIET_DETAIL = "BUS_PHANTUYEN_CLOSE_TUYENDUONG_CHITIET_DETAIL",

	SAVE_TUYENDUONG_CHITIET_START = "BUS_PHANTUYEN_SAVE_TUYENDUONG_CHITIET_START",
	SAVE_TUYENDUONG_CHITIET_SUCCESS = "BUS_PHANTUYEN_SAVE_TUYENDUONG_CHITIET_SUCCESS",
	SAVE_TUYENDUONG_CHITIET_ERROR = "BUS_PHANTUYEN_SAVE_TUYENDUONG_CHITIET_ERROR",

	SHOW_DELETE_TUYENDUONG_CHITIET_CONFIRM = "BUS_PHANTUYEN_SHOW_DELETE_TUYENDUONG_CHITIET_CONFIRM",
	CLOSE_DELETE_TUYENDUONG_CHITIET_CONFIRM = "BUS_PHANTUYEN_CLOSE_DELETE_TUYENDUONG_CHITIET_CONFIRM",

	DELETE_TUYENDUONG_CHITIET_START = "BUS_PHANTUYEN_DELETE_TUYENDUONG_CHITIET_START",
	DELETE_TUYENDUONG_CHITIET_SUCCESS = "BUS_PHANTUYEN_DELETE_TUYENDUONG_CHITIET_SUCCESS",
	DELETE_TUYENDUONG_CHITIET_ERROR = "BUS_PHANTUYEN_DELETE_TUYENDUONG_CHITIET_ERROR",

	SHOW_ADD_HOCSINH_MODAL = "BUS_PHANTUYEN_SHOW_ADD_HOCSINH_MODAL",
	CLOSE_ADD_HOCSINH_MODAL = "BUS_PHANTUYEN_CLOSE_ADD_HOCSINH_MODAL",

	LOAD_HOCSINH_CHUAPHANTUYEN_START = "BUS_PHANTUYEN_LOAD_HOCSINH_CHUAPHANTUYEN_START",
	LOAD_HOCSINH_CHUAPHANTUYEN_SUCCESS = "BUS_PHANTUYEN_LOAD_HOCSINH_CHUAPHANTUYEN_SUCCESS",
	LOAD_HOCSINH_CHUAPHANTUYEN_ERROR = "BUS_PHANTUYEN_LOAD_HOCSINH_CHUAPHANTUYEN_ERROR",

	CHANGE_HOCSINH_CHUAPHANTUYEN_SELECTED_IDS = "BUS_PHANTUYEN_CHANGE_HOCSINH_CHUAPHANTUYEN_SELECTED_IDS",

	SAVE_PHANTUYEN_HOCSINH_START = "BUS_PHANTUYEN_SAVE_PHANTUYEN_HOCSINH_START",
	SAVE_PHANTUYEN_HOCSINH_SUCCESS = "BUS_PHANTUYEN_SAVE_PHANTUYEN_HOCSINH_SUCCESS",
	SAVE_PHANTUYEN_HOCSINH_ERROR = "BUS_PHANTUYEN_SAVE_PHANTUYEN_HOCSINH_ERROR",

	SHOW_DELETE_HOCSINH_CONFIRM = "BUS_PHANTUYEN_SHOW_DELETE_HOCSINH_CONFIRM",
	CLOSE_DELETE_HOCSINH_CONFIRM = "BUS_PHANTUYEN_CLOSE_DELETE_HOCSINH_CONFIRM",

	DELETE_HOCSINH_START = "BUS_PHANTUYEN_DELETE_HOCSINH_START",
	DELETE_HOCSINH_SUCCESS = "BUS_PHANTUYEN_DELETE_HOCSINH_SUCCESS",
	DELETE_HOCSINH_ERROR = "BUS_PHANTUYEN_DELETE_HOCSINH_ERROR",

	SHOW_IMPORT_CHITIET_MODAL = "BUS_PHANTUYEN_SHOW_IMPORT_CHITIET_MODAL",
	CLOSE_IMPORT_CHITIET_MODAL = "BUS_PHANTUYEN_CLOSE_IMPORT_CHITIET_MODAL",

	VALIDATE_IMPORT_CHITIET_START = "BUS_PHANTUYEN_VALIDATE_IMPORT_CHITIET_START",
	VALIDATE_IMPORT_CHITIET_SUCCESS = "BUS_PHANTUYEN_VALIDATE_IMPORT_CHITIET_SUCCESS",
	VALIDATE_IMPORT_CHITIET_ERROR = "BUS_PHANTUYEN_VALIDATE_IMPORT_CHITIET_ERROR",

	IMPORT_CHITIET_START = "BUS_PHANTUYEN_IMPORT_CHITIET_START",
	IMPORT_CHITIET_SUCCESS = "BUS_PHANTUYEN_IMPORT_CHITIET_SUCCESS",
	IMPORT_CHITIET_ERROR = "BUS_PHANTUYEN_IMPORT_CHITIET_ERROR"
}

export interface IBusPhanTuyenLoadStart {
	type: eBusPhanTuyenActionTypeIds.LOAD_START,
	payload: IBusTuyenDuongSelectRequest
}
export interface IBusPhanTuyenLoadSuccess {
	type: eBusPhanTuyenActionTypeIds.LOAD_SUCCESS,
	payload: BusPhanTuyenItemResponse[]
}
export interface IBusPhanTuyenLoadErr {
	type: eBusPhanTuyenActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusPhanTuyenLoadTuyenDuongChiTietStart {
	type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_START,
	payload: IBusTuyenDuongChiTietSelectRequest
}
export interface IBusPhanTuyenLoadTuyenDuongChiTietSuccess {
	type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS,
	payload: BusTuyenDuongChiTietItemResponse[]
}
export interface IBusPhanTuyenLoadTuyenDuongChiTietErr {
	type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR,
	payload: string
}
export interface IBusPhanTuyenLoadDiemDonTraStart {
	type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_START,
	payload: number
}
export interface IBusPhanTuyenLoadDiemDonTraSuccess {
	type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_SUCCESS,
	payload: BusDiemDonTraItemResponse[]
}
export interface IBusPhanTuyenLoadDiemDonTraErr {
	type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_ERROR,
	payload: string
}
export interface IBusPhanTuyenLoadLoaiDiemDonStart {
	type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_START
}
export interface IBusPhanTuyenLoadLoaiDiemDonSuccess {
	type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
	payload: bus_loaidiemdon[]
}
export interface IBusPhanTuyenLoadLoaiDiemDonErr {
	type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
	payload: string
}
export interface IBusPhanTuyenShowTuyenDuongChiTietDetail {
	type: eBusPhanTuyenActionTypeIds.SHOW_TUYENDUONG_CHITIET_DETAIL,
	payload: BusTuyenDuongChiTietItemResponse
}
export interface IBusPhanTuyenCloseTuyenDuongChiTietDetail {
	type: eBusPhanTuyenActionTypeIds.CLOSE_TUYENDUONG_CHITIET_DETAIL
}
export interface IBusPhanTuyenSaveTuyenDuongChiTietStart {
	type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_START,
	payload: bus_tuyenduong_chitiet
}
export interface IBusPhanTuyenSaveTuyenDuongChiTietSuccess {
	type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_SUCCESS,
	payload: boolean
}
export interface IBusPhanTuyenSaveTuyenDuongChiTietErr {
	type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_ERROR,
	payload: string
}
export interface IBusPhanTuyenShowDeleteTuyenDuongChiTietConfirm {
	type: eBusPhanTuyenActionTypeIds.SHOW_DELETE_TUYENDUONG_CHITIET_CONFIRM,
	payload: BusTuyenDuongChiTietItemResponse
}
export interface IBusPhanTuyenCloseDeleteTuyenDuongChiTietConfirm {
	type: eBusPhanTuyenActionTypeIds.CLOSE_DELETE_TUYENDUONG_CHITIET_CONFIRM
}
export interface IBusPhanTuyenDeleteTuyenDuongChiTietStart {
	type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_START,
	payload: number
}
export interface IBusPhanTuyenDeleteTuyenDuongChiTietSuccess {
	type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_SUCCESS
}
export interface IBusPhanTuyenDeleteTuyenDuongChiTietErr {
	type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_ERROR,
	payload: string
}
export interface IBusPhanTuyenShowAddHocSinhModal {
	type: eBusPhanTuyenActionTypeIds.SHOW_ADD_HOCSINH_MODAL,
	payload: IBusPhanTuyenAddHocSinhRequest
}
export interface IBusPhanTuyenCloseAddHocSinhModal {
	type: eBusPhanTuyenActionTypeIds.CLOSE_ADD_HOCSINH_MODAL
}
export interface IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart {
	type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_START,
	payload: IBusTuyenDuongSelectChuaPhanTuyenRequest
}
export interface IBusPhanTuyenLoadHocSinhChuaPhanTuyenSuccess {
	type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_SUCCESS,
	payload: BusHocSinhChuaPhanTuyenResponse[]
}
export interface IBusPhanTuyenLoadHocSinhChuaPhanTuyenErr {
	type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_ERROR,
	payload: string
}
export interface IBusPhanTuyenChangeHocSinhChuaPhanTuyenSelectedIds {
	type: eBusPhanTuyenActionTypeIds.CHANGE_HOCSINH_CHUAPHANTUYEN_SELECTED_IDS,
	payload: number[]
}
export interface IBusPhanTuyenSavePhanTuyenHocSinhStart {
	type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_START,
	payload: IBusTuyenDuongUpdatePhanTuyenHocSinhRequest
}
export interface IBusPhanTuyenSavePhanTuyenHocSinhSuccess {
	type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_SUCCESS
}
export interface IBusPhanTuyenSavePhanTuyenHocSinhErr {
	type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_ERROR,
	payload: string
}
export interface IBusPhanTuyenShowDeleteHocSinhConfirm {
	type: eBusPhanTuyenActionTypeIds.SHOW_DELETE_HOCSINH_CONFIRM,
	payload: BusPhanTuyenItemResponse
}
export interface IBusPhanTuyenCloseDeleteHocSinhConfirm {
	type: eBusPhanTuyenActionTypeIds.CLOSE_DELETE_HOCSINH_CONFIRM
}
export interface IBusPhanTuyenDeleteHocSinhStart {
	type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_START,
	payload: IBusPhanTuyenHuyDangKyRequest
}
export interface IBusPhanTuyenDeleteHocSinhSuccess {
	type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_SUCCESS
}
export interface IBusPhanTuyenDeleteHocSinhErr {
	type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_ERROR,
	payload: string
}
export interface IBusPhanTuyenShowImportChiTietModal {
	type: eBusPhanTuyenActionTypeIds.SHOW_IMPORT_CHITIET_MODAL,
	payload: number
}
export interface IBusPhanTuyenCloseImportChiTietModal {
	type: eBusPhanTuyenActionTypeIds.CLOSE_IMPORT_CHITIET_MODAL
}
export interface IBusPhanTuyenValidateImportChiTietStart {
	type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_START,
	payload: IUploadExcelTuyenDuongChiTietRequest
}
export interface IBusPhanTuyenValidateImportChiTietSuccess {
	type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_SUCCESS,
	payload: any[]
}
export interface IBusPhanTuyenValidateImportChiTietErr {
	type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_ERROR,
	payload: string
}
export interface IBusPhanTuyenImportChiTietStart {
	type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_START,
	payload: IUploadExcelTuyenDuongChiTietRequest
}
export interface IBusPhanTuyenImportChiTietSuccess {
	type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_SUCCESS
}
export interface IBusPhanTuyenImportChiTietErr {
	type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_ERROR,
	payload: string
}

export type IBusPhanTuyenActionTypes = IBusPhanTuyenLoadStart | IBusPhanTuyenLoadSuccess | IBusPhanTuyenLoadErr |
	IBusPhanTuyenLoadTuyenDuongChiTietStart | IBusPhanTuyenLoadTuyenDuongChiTietSuccess | IBusPhanTuyenLoadTuyenDuongChiTietErr |
	IBusPhanTuyenLoadDiemDonTraStart | IBusPhanTuyenLoadDiemDonTraSuccess | IBusPhanTuyenLoadDiemDonTraErr |
	IBusPhanTuyenLoadLoaiDiemDonStart | IBusPhanTuyenLoadLoaiDiemDonSuccess | IBusPhanTuyenLoadLoaiDiemDonErr |
	IBusPhanTuyenShowTuyenDuongChiTietDetail | IBusPhanTuyenCloseTuyenDuongChiTietDetail |
	IBusPhanTuyenSaveTuyenDuongChiTietStart | IBusPhanTuyenSaveTuyenDuongChiTietSuccess | IBusPhanTuyenSaveTuyenDuongChiTietErr |
	IBusPhanTuyenShowDeleteTuyenDuongChiTietConfirm | IBusPhanTuyenCloseDeleteTuyenDuongChiTietConfirm |
	IBusPhanTuyenDeleteTuyenDuongChiTietStart | IBusPhanTuyenDeleteTuyenDuongChiTietSuccess | IBusPhanTuyenDeleteTuyenDuongChiTietErr |
	IBusPhanTuyenShowAddHocSinhModal | IBusPhanTuyenCloseAddHocSinhModal |
	IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart | IBusPhanTuyenLoadHocSinhChuaPhanTuyenSuccess | IBusPhanTuyenLoadHocSinhChuaPhanTuyenErr |
	IBusPhanTuyenChangeHocSinhChuaPhanTuyenSelectedIds |
	IBusPhanTuyenSavePhanTuyenHocSinhStart | IBusPhanTuyenSavePhanTuyenHocSinhSuccess | IBusPhanTuyenSavePhanTuyenHocSinhErr |
	IBusPhanTuyenShowDeleteHocSinhConfirm | IBusPhanTuyenCloseDeleteHocSinhConfirm |
	IBusPhanTuyenDeleteHocSinhStart | IBusPhanTuyenDeleteHocSinhSuccess | IBusPhanTuyenDeleteHocSinhErr |
	IBusPhanTuyenShowImportChiTietModal | IBusPhanTuyenCloseImportChiTietModal |
	IBusPhanTuyenValidateImportChiTietStart | IBusPhanTuyenValidateImportChiTietSuccess | IBusPhanTuyenValidateImportChiTietErr |
	IBusPhanTuyenImportChiTietStart | IBusPhanTuyenImportChiTietSuccess | IBusPhanTuyenImportChiTietErr
